import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import CitrusAdTracker from 'apps/analytics/services/CitrusAdTracker';

import { gtm } from 'apps/gtm';

import { noop } from 'utils/func';

const TRACK_CALLBACK_TIMEOUT = 1000;

export default class FopTrackLink extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    citrusAdData: PropTypes.shape({
      adId: PropTypes.string,
    }),
    className: PropTypes.string,
    gtmData: PropTypes.object,
    gtmDataUrl: PropTypes.string.isRequired,
    gtmEvent: PropTypes.string.isRequired,
    routerPush: PropTypes.func.isRequired,
    pageParameters: PropTypes.object,
    to: PropTypes.string.isRequired,
  };

  static trackTimeout = null;

  componentWillUnmount = () => {
    this.clearTrackTimeout();
  };

  locationChanged = false;

  get gtmData() {
    const {
      gtmData,
      gtmDataUrl,
      pageParameters,
    } = this.props;

    return {
      ...gtmData,
      url: gtmDataUrl,
      ...pageParameters,
    };
  }

  clearTrackTimeout = () => {
    clearTimeout(FopTrackLink.trackTimeout);
  };

  navigateTo = () => {
    if (this.locationChanged) {
      return;
    }

    const { routerPush, to, citrusAdData } = this.props;

    this.clearTrackTimeout();
    this.locationChanged = true;

    routerPush({
      pathname: to,
      state: citrusAdData ? { externalAdData: citrusAdData } : null,
    });
  };

  onClickHandlerProducers = (event) => {
    const isEventWithModifierKeys = Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    const leftClickEvent = event.button === 0;

    const isNormalClick = leftClickEvent && !isEventWithModifierKeys;

    // Opening link in a new tab - we can safely call callback function without postponing click
    if (!isNormalClick) {
      this.trackClickCallback();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    this.clearTrackTimeout();
    FopTrackLink.trackTimeout = setTimeout(this.navigateTo, TRACK_CALLBACK_TIMEOUT);
    this.trackClickCallback(this.navigateTo);
  };

  onClickCallbackProducers = (event) => {
    // Track middle click only - right click doesn't invoke any action on our side
    if (event.button !== 1) {
      return;
    }

    this.onClickHandlerProducers(event);
  };

  trackClickCallback = (callback = noop) => {
    const { citrusAdData, gtmEvent } = this.props;

    Promise.all([
      gtm.triggerAsync(gtmEvent, this.gtmData),
      citrusAdData ? CitrusAdTracker.reportClick(citrusAdData) : Promise.resolve(),
    ]).then(callback);
  };

  render() {
    const { children, className, to } = this.props;
    return (
      <Link
        className={className}
        onAuxClick={this.onClickCallbackProducers}
        onClick={this.onClickHandlerProducers}
        to={to}
      >
        {children}
      </Link>
    );
  }
}
